import {
  ArrayInput,
  maxLength,
  ReferenceInput,
  required,
  SelectInput,
  SimpleFormIterator,
  TextInput,
} from "react-admin";
import { Grid, Typography, useMediaQuery } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { settings } from "app";
import { administrationRequests } from "api/administrationApi";
import { erasmusRequests } from "api/erasmusApi";
import AcademicYearInput from "./AcademicYearInput";
import { CommissionMemberIteratorItem } from "./CommissionMemberFields";
import UniversityFields from "./UniversityFields";
import { validateCommission } from "../utils";

const SaveCampaignForm = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const { setValue } = useFormContext();

  return (
    <Grid
      container
      spacing={2}
      sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
    >
      <Grid
        item
        xs={12}
        md={6}
      >
        <TextInput
          label="Име"
          source="name"
          fullWidth
          validate={[required(), maxLength(200)]}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        <ReferenceInput
          source="structuralUnitId"
          reference={administrationRequests.getStructuralUnitsSelect()}
        >
          <SelectInput
            label="Структурна единица"
            fullWidth
            validate={required()}
            onChange={() => setValue("commissionMembers", [{}])}
          />
        </ReferenceInput>
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        <AcademicYearInput />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        <ReferenceInput
          source="campaignSeason"
          reference={erasmusRequests.getCampaignSeasonsSelect()}
        >
          <SelectInput
            label="Сезон"
            optionText="nameBg"
            fullWidth
            validate={required()}
          />
        </ReferenceInput>
      </Grid>
      <Grid
        item
        xs={12}
      >
        <Typography
          color="primary"
          sx={{ marginTop: "2rem" }}
        >
          Комисия
        </Typography>
        <ArrayInput
          label={false}
          source="commissionMembers"
          fullWidth
          defaultValue={[{}]}
          validate={validateCommission}
        >
          <SimpleFormIterator
            inline={false}
            sx={settings.style.iteratorWithoutGap}
          >
            <CommissionMemberIteratorItem />
          </SimpleFormIterator>
        </ArrayInput>
      </Grid>
      <Grid
        item
        xs={12}
      >
        <Typography
          color="primary"
          sx={{ marginTop: "2rem" }}
        >
          Университети
        </Typography>
        <ArrayInput
          label={false}
          source="universities"
          fullWidth
        >
          <SimpleFormIterator
            inline={false}
            sx={settings.style.iteratorWithoutGap}
          >
            <UniversityFields />
          </SimpleFormIterator>
        </ArrayInput>
      </Grid>
    </Grid>
  );
};

export default SaveCampaignForm;
